import nengi from 'nengi'

class UpdateFTUEMessageIndexMessage {
	static protocol = {
		index: nengi.Int10,
	}

	index: number

	constructor(index: number) {
		this.index = index
	}
}

export default UpdateFTUEMessageIndexMessage
